import { Stack } from '@mui/material';
import { useManage } from '@v2/components/campaign/CampaignAdGroupSection/AdvancedSubflows/AdvancedCreative/Manage/hooks/useManage';
import { ManageListElement } from '@v2/components/campaign/CampaignAdGroupSection/AdvancedSubflows/AdvancedCreative/Manage/ManageListElement';

export const ManageTable = ({
  onSubmit,
  isDisplay,
}: {
  onSubmit: () => void;
  isDisplay: boolean;
}) => {
  const { controlledFields, remove, update, weightingRotation } = useManage({
    onSubmit,
  });

  return (
    <Stack flex={1} spacing={2.5}>
      {controlledFields.map((field, idx) => (
        <ManageListElement
          onRemove={remove(idx)}
          onUpdate={update(idx)}
          field={field}
          weightingRotation={weightingRotation}
          key={field.id}
          index={idx}
          isDisplay={isDisplay}
        />
      ))}
    </Stack>
  );
};
